<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Tyres"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'tyres.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('tyres', 'create') && tyres.length < 1">New Tyres</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('tyres', 'view')">
                <strong class="block mb-4">Publishable:</strong>
                <app-table v-if="tyres.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell class="text-center" :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published At
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(o, i) in tyres" :key="i">
                            <app-table-cell class="text-center">
                                Tyre widget
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <router-link :to="{ name: 'tyres.new.child', params: { id: o.id } }" v-if="o.locale.flag != locale.flag && !isTranslated(o, locale)">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </router-link>
                                    <router-link v-else :to="{ name: 'tyres.edit', params: { id: getId(o, locale) } }">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </router-link>
                                </div>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="o.published ? 'check-circle' : 'times-circle'" :class="{'text-green': o.published, 'text-red': !o.published, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ moment(o.published_at).format('D MMM YY') }}
                                <span class="text-xs block mt-1 text-grey">({{ moment(o.published_at).fromNow() }})</span>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'tyres.edit', params: { id: o.id } }" class="mr-2 text-blue hover:text-blue-darker"  v-if="checkPermission('tyres', 'edit') && o.children.length < 1">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = o.id" v-if="checkPermission('tyres', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="tyres"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>

            <app-box :loading="loading" :initial="loading" class="mt-8" v-if="drafts.length > 0 && checkPermission('tyres', 'view') && checkPermission('tyres', 'publishable')">
                <strong class="block mb-4">Drafted:</strong>
                <app-table>
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'tyres.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('tyres', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('tyres', 'delete')"/>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a tyre. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'tyres.home',

        data: () => ({
            loading: true,
            tyres: [],
            drafts: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal
        },

        mounted() {
            this.getTyres()
                .then(response => {
                    return this.getDraftTyres();
                })
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            getTyres() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                return Api.request('get', `tyres?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.tyres = data.tyres;
                        this.response = data;
                    });
            },
            getDraftTyres() {
                return Api.request('get', `tyres/drafts`)
                    .then(({ data }) => {
                        this.drafts = data.tyres;
                    });
            },
            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteTyres( this.confirmModalId ).then(response => {
                    this.getTyres()
                        .then(response => {
                            return this.getDraftTyres();
                        })
                        .then(response => {
                            this.loading = false;
                            this.confirmModalId = false;
                        });
                });
            },
            deleteTyres(id) {
                return Api.request('get', `tyres/delete/${id}`);
            },
            isTranslated(tyre, locale) {
                let translated = false;

                if (tyre.children.length > 0 && tyre.locale.flag != locale.flag) {
                    tyre.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }

                return translated;
            },
            getId(tyre, locale) {
                let id = tyre.id;

                if (tyre.children.length > 0 && tyre.locale.flag != locale.flag) {
                    tyre.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/tyres/Home.vue